<template>
  <v-app>
    <v-container fluid fill-height>
      <v-row class="text-center" justify="center" align-content="center">
        <v-col cols="12" sm="6" justify="center">
          <v-img
            :src="require('../assets/logo.png')"
            class="my-3"
            contain
            height="80"
          />
          <p class="display-5 mb-1">
            <strong>Hitonobiのエラーです。</strong>
          </p>
          <br />
          <p class="display-5 mb-1">
            再度、ログインしても同じエラーが発生する場合は、
          </p>
          <p class="display-5 mb-1">システム管理者にお問合せをお願いします。</p>
          <br />
          <div class="text-center">
            <v-btn class="ma-2" outlined color="primary" @click="loginBack"
              >ログイン画面に戻る</v-btn
            >
          </div>
          <br />
          <br />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { delSessionStorageItem } from '../common.js';
export default {
  created() {
    delSessionStorageItem();
  },
  methods: {
    loginBack: function () {
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>
